<script setup lang="ts">
import type { IResponseData } from '~/types'
import type { INewsCategory } from '~/components/entity/news-category'
import type { IProps } from './types'

const { t } = useI18n()

const props = withDefaults(defineProps<IProps>(), {
  heading: ''
})

const { data: newsCategories } = useApi<IResponseData<INewsCategory[]>>(
  () => useUrlWithParams('/news_categories?filter[position]=sidebar'),
  {
    key: `news.categories.sidebar`
  }
)

const categoryMenuItems = computed(() => {
  const categories = newsCategories.value
    ? newsCategories.value.data.map((category: INewsCategory) => ({
        title: category.title,
        url: category.url,
        icon: category.slug
      }))
    : []

  return [
    { title: t('common.economy_news'), url: '/news', icon: 'newspaper' },
    ...categories,
    { title: t('common.useful_materials'), url: '/useful-articles', icon: 'info' }
  ]
})

const headingText = computed(() => props.heading || t('common.sections'))
</script>

<template>
  <SidebarBlock
    v-if="categoryMenuItems.length && newsCategories"
    :heading-text="headingText"
    variant="white"
    class="hidden xl:block"
  >
    <SidebarMenu :menu-items="categoryMenuItems" />
  </SidebarBlock>
  <div v-else class="aspect-square rounded-lg bg-white" />
</template>
